// extracted by mini-css-extract-plugin
export default {"price-list":"PriceList_price-list__Kb7k2"};